// extracted by mini-css-extract-plugin
export default {"label":"Label_label__tmwlf","optionalLabel":"Label_optionalLabel__cg5uO","required":"Label_required__jFvSq","optional":"Label_optional__qRL4p"};